@if(noAccess()) {
<div class="app-auth-layout">
    <div class="auth-page">
        <div class="auth-stage">
            <div class="auth-column">
                <img class="auth-logo" src="images/logo.png" alt="Used Photo Pro">
                <div class="auth-card">
                    <div class="card-title">No access yet</div>
                    <div class="card-subtitle">Your account doesn't have permission to any pages. Ask an administrator to add you to a role.</div>
                    <button type="button" class="btn btn-primary w-100" (click)="logout()">Log out</button>
                </div>
            </div>
        </div>
        <div class="auth-footer">NEO 2.0 · Used Photo Pro admin portal</div>
    </div>
</div>
}
